import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, ROLE_HOME } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { DgcEmblem } from "../components/Logo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const u = await login(email, password);
      toast.success(`Akwaaba, ${u.name}`);
      nav(ROLE_HOME[u.role]);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="login-page">
      <div className="relative hidden lg:flex flex-col justify-between p-12 grain bg-[#F4F8F5] border-r border-[color:var(--line)] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1718242567909-882a8bf5f7ea?w=1400&q=80" alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
        <div className="relative"><span className="eyebrow">DGC · Workforce & Intelligence Platform</span></div>
        <div className="relative">
          <DgcEmblem size={120} />
          <h1 className="font-display text-5xl font-bold text-ink mt-8 leading-tight">The command<br /><span className="text-gold">layer of DESPITE.</span></h1>
          <p className="text-slate-400 mt-4 max-w-md">Listener → Content → Staff → Assignment → Broadcast → Sentiment → Executive decision.</p>
        </div>
        <div className="relative kente opacity-70" />
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden mb-8"><DgcEmblem size={64} /></div>
          <div className="eyebrow mb-2">Staff & executive access</div>
          <h2 className="font-display text-3xl text-ink mb-2">Sign in</h2>
          <p className="text-sm text-slate-500 mb-8">Accounts are created by DGC administrators, or by invitation from the partners.</p>
          <label className="text-xs text-slate-400">Email or username</label>
          <input type="text" autoCapitalize="none" required className="field mt-1 mb-4" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          <label className="text-xs text-slate-400">Password</label>
          <input type="password" required className="field mt-1 mb-4" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          {err && <div className="text-sm text-red-400 mb-4" data-testid="login-error">{err}</div>}
          <button disabled={busy} className="btn-gold w-full" data-testid="login-submit-btn">{busy ? "Verifying…" : "Enter the hub"}</button>
          <a href="/" className="block text-center text-xs text-slate-500 hover:text-[color:var(--gold)] mt-6" data-testid="login-back-public">← Back to the public hub</a>
        </form>
      </div>
    </div>
  );
}
